<template>
  <div class="order finDetails">
    <head-panel title="财务管理" subtitle="FINANCIAL MANAGEMENT" :exportUrl="financial.detailsDown"></head-panel>
    <div class="oprPanel">
      <h3 class="subLabel">财务明细</h3>
      <el-tabs v-model="activeName" @tab-click="handleClick" class="is-simple">
        <el-tab-pane label="代理商财务明细" name="1"></el-tab-pane>
        <el-tab-pane label="广告主财务明细" name="5"></el-tab-pane>
      </el-tabs>
      <ny-date-range @change="dateChange" class="el-date-editor" :shortcut="true" v-model="date"></ny-date-range>
      <div class="selectBox clearfix">
        <el-input class="searchBox" icon="search" v-model="accountName" placeholder="请输入账户名称"></el-input>
        <el-input class="searchBox" icon="search" v-model="adverName" placeholder="请输入广告主/代理商名称"></el-input>
        <ny-select
          :data="financial.finTypeMenu"
          v-model="financial.curFinType"
          :keyValue="['value', 'name']"
          @changeSelectMenu="changeSelect"
          part="adr"
          placeholder="请选择"
          class="advertiseSelect input_sm"
        ></ny-select>
        <el-button class="oprSuccess mr55" @click="searchData">搜索</el-button>
      </div>
      <div class="adTable">
        <ny-table
          class="tableBox mt20"
          :page="financial.page"
          :pageFalse="true"
          @size-change="changePageSize"
          @current-change="changePageSize"
          v-loading="loading"
        ></ny-table>
      </div>
    </div>
  </div>
</template>

<script>
import { headPanel, NySelect, NyTable, NyDateRange } from '@/global/components';
import { mapGetters } from 'vuex';
export default {
  name: 'advertiser',
  data () {
    return {
      finType: 0,
      adverName: '',
      accountName: '',
      activeName: '1',
      date: [],
      startTime: '',
      endTime: '',
      addPrice: {
        title: '加款金额',
        type: 'add'
      },
      refund: {
        title: '退款金额',
        type: 'refund'
      },
      loading: false
    };
  },
  computed: {
    ...mapGetters({
      financial: 'finance/financial',
      userid: 'login/userid'
    })
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.$store.dispatch('finance/getFinDetailsTypeMenu', { userType: this.activeName })
      this.getFinDetailsInfo()
    },
    getFinDetailsInfo ({ currentPage, pageSize } = {}) {
      let usertype = this.activeName === '5' ? '4' : this.activeName
      this.$store.dispatch('finance/getFinDetailsTable', {
        userType: usertype,
        parentId: this.userid,
        userName: this.adverName,
        accountName: this.accountName,
        currentPage,
        pageSize,
        userId: this.userid,
        startTime: this.startTime,
        endTime: this.endTime,
        type: this.financial.curFinType
      })
    },
    changeSelect (val) {
    },
    changePageSize ({ currentPage, pageSize } = {}) {
      this.getFinDetailsInfo({ currentPage, pageSize })
    },
    handleClick (val) {
      this.$store.dispatch('finance/getFinDetailsTypeMenu', { userType: this.activeName })
      this.financial.page.resetData()
      this.getFinDetailsInfo()
    },
    disDate (time) {
      return new Date(time) > Date.now();
    },
    dateChange (date) {
      this.startTime = date[0]
      this.endTime = date[1]
    },
    searchData () {
      this.financial.page.resetData()
      this.getFinDetailsInfo()
    }
  },
  components: {
    headPanel,
    NySelect,
    NyTable,
    NyDateRange
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss">
.finDetails {
  .add_order {
    width: 114px;
    b {
      float: left;
      font-size: 20px;
      font-weight: 600;
      margin-top: 0px;
    }
  }
  .tabs-select {
    margin-top: 20px;
    margin-left: 20px;
    .el-tabs__header {
      margin-bottom: 20px;
    }
  }
  .el-date-editor {
    margin-left: 20px;
  }
  .selectBox {
    margin-top: 20px;
    .el-select {
      width: 230px;
    }
  }
  .priceCus {
    .el-dialog {
      width: 500px;
    }
  }
}
</style>
